import createReducer from 'utils/redux/createReducer'
import combineReducers from 'utils/redux/combineReducers'

// const initialState = {
// 	property: {sortBy: "status", sortDirection: "ASC"}
//   , project: {sortBy: "propertyAlias", sortDirection: "ASC"}
//   , transaction: {sortBy: "dueDate", sortDirection: "DESC"}
// }
//
// export default createReducer(initialState, {
//     SORT_CHANGE: (currentState, action) => ({
//         ...currentState
//       , [action.data.entity]: {sortBy: action.data.sortBy, sortDirection: action.data.sortDirection}
//     })
// })

let reducer = (entity, initialState) => {
    return createReducer(initialState, {
		SORT_CHANGE: (state, action) => (
			action.data.entity == entity
				? {sortBy: action.data.sortBy, sortDirection: action.data.sortDirection}
				: state
		)
    })
}
export default combineReducers({
    property: reducer('property', {sortBy: "status", sortDirection: "ASC"})
  , project: reducer('project', {sortBy: "propertyAlias", sortDirection: "ASC"})
  , transaction: reducer('transaction', {sortBy: "dueDate", sortDirection: "DESC"})
  , task: reducer('task', {sortBy: "status", sortDirection: "ASC"})
  , tenant: reducer('tenant', {sortBy: "tenant", sortDirection: "ASC"})
  , lease: reducer('lease', {sortBy: "dateTill", sortDirection: "ASC"})
  , all: reducer('all', {sortBy: "type", sortDirection: "ASC"})
})



// WEBPACK FOOTER //
// ./src/reducers/sort.js